import { render, staticRenderFns } from "./TransitionMovementModal.vue?vue&type=template&id=67157fc6&"
import script from "./TransitionMovementModal.vue?vue&type=script&lang=js&"
export * from "./TransitionMovementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports